<nz-spin class="retention-purchase__spin" [nzSpinning]="submitting" testId="retention-purchase-spin">
  <div class="retention-purchase" testId="retention-purchase-modal">
    <div class="retention-purchase__hero" testId="retention-purchase-hero">
      <div>
        <div class="retention-tabs" *ngIf="viewStep === 'options'">
          <button
            type="button"
            class="retention-tabs__item"
            *ngFor="let tab of availableTabs; trackBy: trackTab"
            [class.is-active]="activeTab === tab.key"
            (click)="selectOverviewTab(tab.key)"
            [testId]="'retention-purchase-tab-' + tab.key"
          >
            {{ tab.label }}
          </button>
        </div>
        <h2 class="retention-purchase__title" testId="retention-purchase-title">{{ stepTitle }}</h2>
        <p class="retention-purchase__subtitle" testId="retention-purchase-subtitle">{{ stepSubtitle }}</p>
      </div>
      <button
        type="button"
        class="retention-purchase__close"
        (click)="close()"
        [attr.aria-label]="'common.close' | i18n"
        testId="retention-purchase-close-button"
        >×</button
      >
    </div>

    <div class="retention-current" *ngIf="shouldShowCurrentConfig" testId="retention-purchase-current">
      <div class="retention-current__header">{{ currentConfigTitle }}</div>
      <div class="retention-current__grid">
        <div class="retention-current__panel">
          <div class="retention-current__panel-label">{{ currentPrimaryLabel }}</div>
          <div class="retention-current__value">{{ currentValue }}</div>
          <div class="retention-current__panel-hint" *ngIf="currentPrimaryHint">{{ currentPrimaryHint }}</div>
        </div>
        <div class="retention-current__panel">
          <div class="retention-current__panel-label">{{ currentStatusMetaLabel }}</div>
          <div class="retention-current__status" [class.is-enabled]="hasActivePrivilege" [class.is-warning]="hasPendingPrivilege">
            {{ currentStatusMetaValue }}
          </div>
          <div class="retention-current__status-hint">{{ currentStatusMetaHint }}</div>
        </div>
      </div>
    </div>

    <ng-container *ngIf="viewStep === 'options'; else paymentStepTpl">
      <ng-container *ngIf="showPurchaseTab">
        <div
          class="retention-scenario"
          [class.is-warning]="scenarioTone === 'warning'"
          [class.is-positive]="scenarioTone === 'positive'"
          testId="retention-purchase-scenario"
        >
          <div class="retention-scenario__title">{{ scenarioTitle }}</div>
          <div class="retention-scenario__desc" [innerHTML]="scenarioHintHtml"></div>
          <div class="retention-scenario__pending" *ngIf="pendingPrivilege as pending">
            <span>{{ 'quota.view.retention.modal.pending-plan-inline' | i18n }}</span>
            <strong>{{ formatRetentionDays(pending.retentionDays) }}</strong>
          </div>
        </div>

        <div class="retention-options" *ngIf="shouldShowOptionSelection" testId="retention-purchase-options">
          <div class="retention-options__head">
            <div class="retention-options__title">{{ 'quota.view.retention.modal.select-plan' | i18n }}</div>
          </div>

          <ng-container *ngIf="hasOptions; else emptyTpl">
            <div class="option-grid">
              <button
                type="button"
                class="option-card"
                *ngFor="let option of options; let i = index; trackBy: trackOption"
                [class.is-recommend]="option.recommend"
                [class.is-selected]="isSelectedOption(option)"
                (click)="selectOption(option)"
                [testId]="'retention-purchase-option-' + i"
              >
                <div class="option-card__flags">
                  <div
                    class="option-card__selected"
                    *ngIf="isSelectedOption(option)"
                    [attr.aria-label]="'quota.view.retention.modal.selected' | i18n"
                  >
                    <span class="option-card__selected-icon">✓</span>
                  </div>
                </div>
                <div class="option-card__title-row">
                  <div class="option-card__title">{{ option.title }}</div>
                  <div class="option-card__badge option-card__badge--inline" *ngIf="option.recommend">
                    {{ 'quota.view.retention.modal.recommend' | i18n }}
                  </div>
                </div>
                <div class="option-card__desc" *ngIf="option.description">{{ option.description }}</div>
                <div class="option-card__price" *ngIf="!shouldShowOptionUpgradePreview(option); else upgradePriceTpl">{{
                  option.priceText
                }}</div>
                <ng-template #upgradePriceTpl>
                  <div class="option-card__price option-card__price--upgrade option-card__price-summary">
                    <div class="option-card__price-original">{{ option.priceText }}</div>
                    <div class="option-card__price-current">
                      <span>{{ 'quota.view.retention.modal.upgrade-price' | i18n }}</span>
                      <strong>{{ getOptionUpgradePayableText(option) }}</strong>
                    </div>
                    <div class="option-card__price-credit">
                      <span>{{ 'quota.view.retention.modal.credit-applied' | i18n }}</span>
                      <strong>{{ getOptionUpgradeCreditCashText(option) }}</strong>
                    </div>
                    <div class="option-card__price-credit" *ngIf="getOptionEstimatedRefundPoints(option) > 0">
                      <span>{{ 'quota.view.retention.modal.estimated-refund-points' | i18n }}</span>
                      <strong>{{ getOptionEstimatedRefundPointsText(option) }}</strong>
                    </div>
                  </div>
                </ng-template>
                <div class="option-card__extra" *ngIf="option.extraText">{{ option.extraText }}</div>
                <div class="option-card__extra option-card__extra--hint" *ngIf="getOptionPriceHint(option)">
                  {{ getOptionPriceHint(option) }}
                </div>
              </button>
            </div>
          </ng-container>
        </div>

        <div
          class="retention-terms"
          *ngIf="showTermsConfirmation && shouldShowOptionSelection"
          [class.is-warning]="purchaseScenario === 'downgrade'"
        >
          <div class="retention-terms__title">{{ 'quota.view.retention.modal.terms-title' | i18n }}</div>
          <div class="retention-terms__summary">{{ termsSummary }}</div>
          <ul class="retention-terms__list">
            <li class="retention-terms__item" *ngFor="let item of termsItems">{{ item }}</li>
          </ul>
          <label class="retention-terms__ack">
            <input type="checkbox" [(ngModel)]="termsAck" testId="retention-purchase-terms-checkbox" />
            <span>{{ termsAckText }}</span>
          </label>
        </div>

        <div class="option-actions" *ngIf="shouldShowOptionSelection">
          <div class="option-actions__buttons">
            <button nz-button nzType="default" (click)="close()" testId="retention-purchase-cancel-button">{{
              'common.cancel' | i18n
            }}</button>
            <button
              nz-button
              nzType="primary"
              [disabled]="!canProceedPurchase"
              (click)="proceedToPayment()"
              testId="retention-purchase-proceed-button"
              >{{ scenarioTitle }}</button
            >
          </div>
        </div>
      </ng-container>

      <div class="retention-insights" *ngIf="showUnpaidTab">
        <div class="retention-insight retention-insight--warning">
          <div class="retention-insight__title">待支付延長包</div>
          <div class="retention-insight__body">
            <div class="retention-insight__row" *ngIf="showUnpaidOrderPlan">
              <span>方案規格</span>
              <strong>{{ unpaidOrderPlanText }}</strong>
            </div>
            <div class="retention-insight__row" *ngIf="showUnpaidOrderPrice">
              <span>待支付金額</span>
              <strong>{{ unpaidOrderPriceText }}</strong>
            </div>
            <div class="retention-insight__row" *ngIf="showUnpaidOrderCreateDate">
              <span>建立日期</span>
              <strong>{{ unpaidOrderCreateDateText }}</strong>
            </div>
            <div class="retention-insight__row">
              <span>支付保留至</span>
              <strong>{{ unpaidOrderExpireDateText }}</strong>
            </div>
            <div class="retention-insight__row">
              <span>剩餘支付時間</span>
              <strong [class.retention-insight__value-expired]="isUnpaidOrderExpired">{{ unpaidOrderCountdownText }}</strong>
            </div>
          </div>
          <div class="retention-insight__hint">{{ unpaidOrderHint }}</div>
          <div class="retention-insight__actions">
            <button
              nz-button
              nzType="primary"
              class="retention-insight__button"
              *ngIf="!isUnpaidOrderExpired"
              [disabled]="!canContinueUnpaidOrderPayment"
              (click)="continueUnpaidOrderPayment()"
              testId="retention-purchase-continue-unpaid-button"
            >
              繼續支付
            </button>
            <button
              nz-button
              nzType="default"
              class="retention-insight__button retention-insight__button--danger"
              [disabled]="!canDeleteUnpaidOrder"
              (click)="cancelUnpaidOrder()"
              testId="retention-purchase-delete-unpaid-button"
            >
              刪除訂單
            </button>
          </div>
        </div>
      </div>

      <ng-container *ngIf="showQueuedTab">
        <div class="retention-insights" *ngIf="pendingPrivilege as pending">
          <div class="retention-insight retention-insight--warning">
            <div class="retention-insight__title">{{ 'quota.view.retention.modal.pending-plan-manage' | i18n }}</div>
            <div class="retention-insight__body">
              <div class="retention-insight__row">
                <span>{{ 'quota.view.retention.modal.pending-plan-spec' | i18n }}</span>
                <strong>{{ formatRetentionDays(pending.retentionDays) }}</strong>
              </div>
              <div class="retention-insight__row">
                <span>{{ 'quota.view.retention.modal.pending-plan-activate-date' | i18n }}</span>
                <strong>{{ queueActivationDateText }}</strong>
              </div>
              <div class="retention-insight__row" *ngIf="pendingRefundPoints > 0">
                <span>{{ 'quota.view.retention.modal.pending-plan-refund' | i18n }}</span>
                <strong>{{ pendingRefundPointsText }}</strong>
              </div>
            </div>
            <div class="retention-insight__hint">{{ pendingCancelHint }}</div>
            <div class="retention-insight__actions" *ngIf="showPendingCancelPlaceholder">
              <button
                nz-button
                nzType="default"
                class="retention-insight__button"
                [disabled]="!canCancelPendingPrivilege"
                (click)="cancelPendingPrivilege()"
                testId="retention-purchase-cancel-pending-button"
              >
                {{ 'quota.view.retention.modal.cancel-pending-plan' | i18n }}
              </button>
            </div>
            <div class="retention-insight__hint" *ngIf="!showPendingCancelPlaceholder">
              {{ pendingCancelUnavailableText }}
            </div>
          </div>
        </div>
      </ng-container>
    </ng-container>

    <ng-template #paymentStepTpl>
      <div class="payment-step" testId="retention-purchase-payment-step">
        <div class="selected-card">
          <div class="selected-card__row">
            <span>{{ 'quota.view.retention.modal.quota-item' | i18n }}</span>
            <strong>{{ quotaName }}</strong>
          </div>
          <div class="selected-card__row">
            <span>{{ 'quota.view.retention.modal.plan' | i18n }}</span>
            <strong>{{ selectedOption?.title }}</strong>
          </div>
          <div class="selected-card__row selected-card__row--price">
            <span>{{ 'quota.view.retention.modal.package-price' | i18n }}</span>
            <strong>{{ selectedOption?.priceText }}</strong>
          </div>
        </div>

        <div class="payment-callout payment-callout--info" *ngIf="purchaseScenario === 'renew'">
          {{ 'quota.view.retention.modal.callout-renew' | i18n }}
        </div>

        <div class="payment-callout payment-callout--info" *ngIf="purchaseScenario === 'upgrade'">
          {{ 'quota.view.retention.modal.callout-upgrade' | i18n }}
        </div>

        <div class="payment-callout payment-callout--warning" *ngIf="purchaseScenario === 'downgrade'">
          {{ 'quota.view.retention.modal.callout-downgrade' | i18n }}
        </div>

        <div
          class="deduct-card"
          *ngFor="let card of balanceCards"
          [class]="'deduct-card deduct-card--' + card.type"
          [testId]="'retention-purchase-deduct-card-' + card.type"
        >
          <div class="deduct-card__head">
            <div class="deduct-card__title">
              <span class="deduct-card__title-icon deduct-card__title-icon--uupon" aria-hidden="true"></span>
              <span>{{ getBalanceTypeLabel(card.type) }}</span>
            </div>
            <div class="deduct-card__meta">{{ getBalancePointsLabel(card.points) }}</div>
          </div>

          <div class="deduct-card__controls">
            <input
              class="deduct-input"
              type="text"
              inputmode="numeric"
              pattern="[0-9]*"
              [disabled]="isDeductInputDisabled(card.type)"
              [ngModel]="deductionInputs[card.type]"
              (beforeinput)="blockNonIntegerInput($event)"
              (input)="onDeductInput(card.type, $event)"
              [placeholder]="'quota.view.retention.modal.input-deduct-points' | i18n"
              [testId]="'retention-purchase-deduct-input-' + card.type"
            />
            <button
              nz-button
              nzType="default"
              nzSize="small"
              class="deduct-card__all"
              [disabled]="isDeductInputDisabled(card.type)"
              (click)="deductAll(card.type)"
              [testId]="'retention-purchase-deduct-all-button-' + card.type"
            >
              {{ 'quota.view.retention.modal.use-all' | i18n }}
            </button>
          </div>
          <div class="deduct-card__foot">
            <div class="deduct-rate">{{ getDeductRateText(card.deductRate) }}</div>
            <div class="deduct-amount">{{ getDeductAmountText(card.type) }}</div>
          </div>
        </div>

        <div class="cost-summary">
          <div class="cost-summary__row">
            <span>{{ 'quota.view.retention.modal.package-price' | i18n }}</span>
            <strong>{{ selectedOption?.priceText }}</strong>
          </div>
          <div class="cost-summary__row cost-summary__row--estimate" *ngIf="shouldShowUpgradeEstimate">
            <span>{{ 'quota.view.retention.modal.estimated-original-plan-credit' | i18n }}</span>
            <strong>{{ upgradeCreditCashText }}</strong>
          </div>
          <div class="cost-summary__row cost-summary__row--estimate" *ngIf="selectedOptionEstimatedRefundPoints > 0">
            <span>{{ 'quota.view.retention.modal.estimated-refund-points' | i18n }}</span>
            <strong>{{ selectedOptionEstimatedRefundPointsText }}</strong>
          </div>
          <div
            class="cost-summary__row"
            *ngFor="let card of balanceCards"
            [class]="'cost-summary__row cost-summary__row--deduct cost-summary__row--' + card.type"
            [hidden]="getDeductPoints(card.type) <= 0"
          >
            <span>{{ getBalanceTypeLabel(card.type) }}</span>
            <strong>-{{ getDeductDisplay(card.type) }}</strong>
          </div>
          <div class="cost-summary__divider"></div>
          <div class="cost-summary__row cost-summary__row--payable">
            <span>{{
              shouldShowUpgradeEstimate
                ? ('quota.view.retention.modal.estimated-payable' | i18n)
                : ('quota.view.retention.modal.payable' | i18n)
            }}</span>
            <strong>{{ displayedPayableDisplay }}</strong>
          </div>
          <div class="cost-summary__hint">
            {{
              shouldShowUpgradeEstimate
                ? ('quota.view.retention.modal.estimated-credit-hint' | i18n)
                : ('quota.view.retention.modal.payable-hint' | i18n)
            }}
          </div>
        </div>

        <div class="payment-actions">
          <button nz-button nzType="default" (click)="close()" testId="retention-purchase-payment-cancel-button">{{
            'common.cancel' | i18n
          }}</button>
          <button
            nz-button
            nzType="primary"
            [nzLoading]="submitting"
            [disabled]="submitting"
            (click)="confirmPay()"
            testId="retention-purchase-confirm-pay-button"
          >
            {{ 'quota.view.retention.modal.confirm-pay' | i18n }}
          </button>
        </div>
      </div>
    </ng-template>

    <ng-template #emptyTpl>
      <nz-empty [nzNotFoundContent]="'quota.view.retention.modal.empty' | i18n" testId="retention-purchase-empty" />
    </ng-template>
  </div>
</nz-spin>
